import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateFilter'
})
export class DateFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    if (typeof value === "number") {

      return moment().isoWeekday(value).format(args);
    }
    return moment(value).format(args);
  }

}
